/**
 * @file This file defines the available asset modes for the application.
 * These modes are used to populate a dropdown menu that allows the user to select a linking option.
 */
export const assetModes = [
    { label: 'Select link options', value: '' },
    { label: 'Link to EB data', value: 'link2AirTable' },
    { label: 'Link to Excel', value: 'link2Excel' }
];
